export default __webpack_public_path__ + "static/media/laptop.6034cd51.svg";